import React, { useContext, useState } from "react";
import { FiBell, FiChevronDown, FiUser, FiLogOut } from "react-icons/fi";
import { DContext } from "../../context/Datacontext";
import { useNavigate } from "react-router-dom";

export const AppHeader = ({ setMobileOpen }) => {

  const { currentUser, handleLogout } = useContext(DContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleProfile = () => {

    setMenuOpen(false);

    if (["admin", "superadmin"].includes(currentUser?.role)) {
      navigate("/app/profile");
    } else {
      navigate("/instructor/my/profile");
    }

  };

  const handleLogoutClick = () => {
    setMenuOpen(false);
    handleLogout();
  };

  return (

    <header className="h-16 bg-white border-b flex items-center justify-between lg:justify-end px-6">
      {/* Mobile Menu */}
      <button
        onClick={() => setMobileOpen(true)}
        className="lg:hidden p-2 hover:bg-gray-100 rounded-md"
      >
        ☰
      </button>

      {/* Right Side */}
      <div className="flex items-center gap-4 relative">

        {/* Notification */}
        <button
          onClick={() =>
            ["admin", "superadmin"].includes(currentUser?.role)
              ? navigate("/app/notifications")
              : navigate("/instructor/notifications")
          }
          className="p-2 hover:bg-gray-100 rounded-md transition"
        >
          <FiBell size={20} />
        </button>

        {/* User */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="flex items-center gap-2"
        >

          <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
            {currentUser?.fullName?.charAt(0)}
          </div>

          <div className="hidden md:block text-sm text-left">
            <div className="font-medium">
              {currentUser?.fullName}
            </div>

            <div className="text-xs text-gray-500 capitalize">
              {currentUser?.role}
            </div>
          </div>

          <FiChevronDown size={16} />

        </button>

        {/* Dropdown */}
        {menuOpen && (
          <div className="absolute right-0 top-12 w-48 bg-white border rounded-lg shadow-lg py-2 animate-fadeIn">
            <button
              onClick={handleProfile}
              className="w-full flex items-center gap-2 text-left px-4 py-2 hover:bg-gray-100 text-sm"
            >
              <FiUser size={16} />
              My Profile
            </button>

            <button
              onClick={handleLogoutClick}
              className="w-full flex items-center gap-2 text-left px-4 py-2 hover:bg-red-50 text-red-600 text-sm"
            >
              <FiLogOut size={16} />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>

  );

};